export const MAX_SHADER_SOURCE_LENGTH = 50_000;

export interface SkyspaceShader {
  preset?: string;
  code?: string;
  attribution?: string;
  attributionUrl?: string;
}

export interface ShaderPreset {
  id: string;
  name: string;
}

export interface ShaderPresetDefinition extends ShaderPreset {
  code: string;
}

export const shaderPresets: ShaderPreset[] = [
  { id: 'pearlescent', name: 'Pearlescent' },
  { id: 'starfield', name: 'Starfield' },
  { id: 'plasma', name: 'Electric Plasma' },
  { id: 'aurora', name: 'Aurora Ribbons' },
  { id: 'lava-lamp', name: 'Lava Lamp' },
  { id: 'ocean-caustics', name: 'Ocean Caustics' },
  { id: 'pixel-rain', name: 'Pixel Rain' },
  { id: 'candy-vortex', name: 'Candy Vortex' },
];

export function shaderPreset(id?: string): ShaderPreset | undefined {
  return shaderPresets.find(preset => preset.id === id);
}

export function customShaderSource(shader?: SkyspaceShader): string {
  return shader?.preset === 'custom' ? shader.code?.trim() || '' : '';
}

export function shaderSourceProblem(source: string): string | undefined {
  const trimmed = source.trim();
  if (!trimmed) return 'Add some shader code before saving.';
  if (trimmed.length > MAX_SHADER_SOURCE_LENGTH) {
    return `Shader code must be ${MAX_SHADER_SOURCE_LENGTH.toLocaleString('en-GB')} characters or fewer.`;
  }
  if (!/\bvoid\s+mainImage\s*\(/.test(trimmed)) {
    return 'The shader needs a ShaderToy-style mainImage function.';
  }
  if (/\biChannel[0-3]\b/.test(trimmed)) {
    return 'Texture and buffer channels are not supported in this version.';
  }
  return undefined;
}
